import { effect, signal } from "@preact/signals-react";
import { ORG_NODE_CHANGED_EVENT, ORG_NODE_STORAGE_KEY, isInternalOrgNodeId, } from "@pdpp/lib-planta";
import { getShareableSetting, setShareableSetting, } from "../shared/services/transforms";
const KEY = ORG_NODE_STORAGE_KEY;
const migrateOldKey = () => {
    if (typeof window === "undefined") {
        return null;
    }
    const newValue = getShareableSetting(KEY);
    if (newValue != null && newValue !== "")
        return newValue;
    const oldValue = getShareableSetting("selectedOrgNode");
    if (oldValue != null && oldValue !== "") {
        localStorage.removeItem("selectedOrgNode");
        if (isInternalOrgNodeId(oldValue))
            return oldValue;
        setShareableSetting(KEY, oldValue);
        return oldValue;
    }
    return null;
};
const initialSelectedOrgNode = migrateOldKey() ?? undefined;
export const selectedOrgNode$ = signal(initialSelectedOrgNode);
let isUpdatingFromListener = false;
let isDispatchingEvent = false;
let isInitialized = false;
let lastReceivedExternalOrgNode = "";
export const setOrgSelectDispatching = (value) => {
    isDispatchingEvent = value;
};
export const getLastReceivedExternalOrgNode = () => lastReceivedExternalOrgNode;
effect(() => {
    const value = selectedOrgNode$.value;
    if (!isInitialized) {
        isInitialized = true;
        return;
    }
    if (isUpdatingFromListener) {
        isUpdatingFromListener = false;
        return;
    }
    try {
        if (value !== undefined && value !== "") {
            if (!isInternalOrgNodeId(value)) {
                setShareableSetting(KEY, value);
            }
        }
    }
    catch (error) {
        console.error("Error in org node sync effect:", error);
        isUpdatingFromListener = false;
    }
});
if (typeof window !== "undefined") {
    const handleOrgNodeChange = (newOrgNode) => {
        if (newOrgNode === null ||
            newOrgNode === "" ||
            newOrgNode === selectedOrgNode$.value)
            return;
        isUpdatingFromListener = true;
        selectedOrgNode$.value = newOrgNode;
    };
    window.addEventListener(ORG_NODE_CHANGED_EVENT, ((event) => {
        if (isDispatchingEvent)
            return;
        const orgNode = event.detail?.orgNode;
        if (orgNode) {
            lastReceivedExternalOrgNode = orgNode;
            handleOrgNodeChange(orgNode);
        }
    }));
    window.addEventListener("storage", (event) => {
        if (event.key != null && event.key.startsWith("msal.")) {
            return;
        }
        if (event.key === KEY && event.newValue !== null && event.newValue !== "") {
            lastReceivedExternalOrgNode = event.newValue;
            handleOrgNodeChange(event.newValue);
        }
    });
}
//# sourceMappingURL=orgSelect.js.map